import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Every route change starts at the top of the page, so the browser's own
// history scroll restoration has nothing useful to add - and on iOS it is
// actively harmful. On Back, WebKit restores the previous page's scroll
// offset at the same moment we start a SMOOTH scroll to the top while React
// is swapping the whole page underneath. The scroll animation ends up at an
// offset the web content process never painted for, and the screen stays
// white (with the fixed tab bar still visible) until something else forces
// a repaint - a swipe, or a later re-render. Reproduced in the simulator on
// the exact 1.129 code (869efw67t, 869ej12gv, 869ehe46v, 869ejeqpx).
//
// Instant scroll and manual restoration remove both halves of that fight.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
